import { probabilitiesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_PROBABILITY,
  FETCHING_PROBABILITY,
  FETCH_PROBABILITY_ERROR,
  FETCH_PROBABILITIES,
  FETCH_PROBABILITIESALL,
  FETCHING_PROBABILITIES,
  FETCH_PROBABILITIES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_PROBABILITY,
  DELETE_PROBABILITY,
  ADD_PROBABILITY,
  EDIT_PROBABILITY,
  FORM_TOUCHED,
  NEW_FORM_PROBABILITY,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  PROBABILITY_FORM_ERROR,
  RESET_STATE
} = probabilitiesActions

const initialState = {
  loadingProbability: false,
  loadingProbabilities: false,
  fetchProbabilityError: false,
  fetchProbabilitiesError: false,
  probabilities: [],
  order: {
    column: 'nome',
    direction: 1
  },
  probability: {
    nome: ''
  },
  probabilitiesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  probabilityFormErrors: {},
  probabilityFormTouched: false,
  modalOpen: false
}

const probabilitySchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const ProbabilityValidate = new ValidateFormObject(probabilitySchema)

const probabilities = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_PROBABILITY:
      formSchemaType = action.probability._id ? 'edit' : 'add'
      return {
        ...state,
        probability: action.probability,
        probabilityFormErrors: ProbabilityValidate.validate({
          formObject: action.probability,
          formSchemaType
        })
      }
    case PROBABILITY_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.probability._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        probabilityFormErrors: ProbabilityValidate.validate({
          formObject: state.probability,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_PROBABILITY:
      return {
        ...state,
        probability: { ...initialState.probability },
        probabilityFormErrors: ProbabilityValidate.validate({}),
        probabilityFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        probabilityFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_PROBABILITY:
      formSchemaType = (action.probability || {})._id ? 'edit' : 'add'
      return {
        ...state,
        probability: action.probability,
        loadingProbability: false,
        fetchprobabilityError: false,
        probabilityFormTouched: false,
        probabilityFormErrors: ProbabilityValidate.validate({
          formObject: action.probability,
          formSchemaType
        })
      }
    case FETCHING_PROBABILITY:
      return {
        ...state,
        loadingProbability: true,
        fetchProbabilityError: false
      }
    case DELETE_PROBABILITY:
      return {
        ...state,
        loadingProbabilities: false,
        fetchProbabilityError: false,
        probabilities: state.probabilities.map(probability => {
          if (probability._id === (action.probability || {})._id) {
            return action.probability
          }
          return probability
        })
      }
    case FETCH_PROBABILITY_ERROR:
      return {
        ...state,
        loadingProbability: false,
        probability: { ...initialState.probability },
        fetchProbabilityError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        probabilitiesPagination: {
          ...state.probabilitiesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        probabilitiesPagination: {
          ...state.probabilitiesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_PROBABILITIESALL:
      return {
        ...state,
        probabilities: action.probabilities
      }
    case FETCH_PROBABILITIES:
      return {
        ...state,
        loadingProbabilities: false,
        probabilities: action.probabilities,
        fetchProbabilitiesError: false,
        order: action.order,
        probabilitiesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_PROBABILITY:
      return {
        ...state,
        probabilities: state.probabilities.map(probability => {
          if (probability._id === action.probability._id) {
            return action.probability
          }
          return probability
        }),
        loadingProbabilities: false,
        fetchProbabilityError: false,
        loadingProbability: false,
        fetchProbabilitiesError: false
      }
    case FETCHING_PROBABILITIES:
      return {
        ...state,
        loadingProbabilities: true,
        fetchProbabilitiesError: false
      }
    case FETCH_PROBABILITIES_ERROR:
      return {
        ...state,
        loadingProbabilities: false,
        fetchProbabilityError: action.error,
        loadingProbability: false
      }
    case ADD_PROBABILITY:
      return {
        ...state,
        loadingProbabilities: false,
        fetchProbabilityError: false,
        loadingProbability: false,
        probabilities: [...state.probabilities, action.probability]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default probabilities



// WEBPACK FOOTER //
// ./src/reducers/probabilities.js